export default __webpack_public_path__ + "static/media/skills.0a5b213b.svg";